import { render, staticRenderFns } from "./create-step-2.vue?vue&type=template&id=4ce83a9c&scoped=true&"
import script from "./create-step-2.vue?vue&type=script&lang=js&"
export * from "./create-step-2.vue?vue&type=script&lang=js&"
import style0 from "./create-step-2.vue?vue&type=style&index=0&id=4ce83a9c&lang=scss&scoped=true&"
import style1 from "./create-step-2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce83a9c",
  null
  
)

export default component.exports